import React from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import { indexMap } from '@helpers'
import BlockTitle from '@components/BlockTitle'
import PpeItem from './PpeItem'
import './PpeItemList.module.scss'

const renderPpeItems = indexMap((item, index) =>
  <PpeItem
    key={R.propOr(index, 'contentful_id', item)}
    title={R.prop('title', item)}
    description={R.pathOr('', ['description', 'description'], item)}
  />
)

const PpeItemList = ({ items }) => (
  <div>
    <BlockTitle title='PPE Requirements' size='medium' background='blue' />
    <div styleName='item-list'>
      {renderPpeItems(items)}
    </div>
  </div>
)

PpeItemList.propTypes = {
  items: PropTypes.array
}

PpeItemList.defaultProps = {
  items: []
}

export default PpeItemList



// WEBPACK FOOTER //
// ./src/components/PpeItemList/PpeItemList.js